const SIDEBAR_KEY = "sidebarCollapsed";

function loadCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export default {
  state: {
    sidebarCollapsed: loadCollapsed(),
    visitedViews: [],
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      try {
        localStorage.setItem(SIDEBAR_KEY, state.sidebarCollapsed ? "1" : "0");
      } catch (e) {
        /* ignore */
      }
    },
    addVisitedView(state, view) {
      if (!view || !view.path) return;
      const exist = state.visitedViews.find((v) => v.path === view.path);
      if (exist) {
        exist.fullPath = view.fullPath;
        if (view.title) {
          exist.title = view.title;
        }
        return;
      }
      if (!view.title) {
        return;
      }
      state.visitedViews.push({
        path: view.path,
        fullPath: view.fullPath || view.path,
        title: view.title,
        affix: !!view.affix,
      });
    },
    delVisitedView(state, path) {
      state.visitedViews = state.visitedViews.filter((v) => v.path !== path || v.affix);
    },
    delOthersVisitedViews(state, path) {
      state.visitedViews = state.visitedViews.filter((v) => v.path === path || v.affix);
    },
    delLeftVisitedViews(state, path) {
      const idx = state.visitedViews.findIndex((v) => v.path === path);
      if (idx <= 0) return;
      state.visitedViews = state.visitedViews.filter((v, i) => i >= idx || v.affix);
    },
    delAllVisitedViews(state) {
      state.visitedViews = state.visitedViews.filter((v) => v.affix);
    },
    clearVisitedViews(state) {
      state.visitedViews = [];
    },
  },
};
